@if (_job != null) {
  <div
    class="jobs-card"
    [ngClass]="{ selected: _job['selected'] }"
    (mouseenter)="hovering = true"
    (mouseleave)="hovering = false"
  >
    @if (!templateManager) {
      <div class="company-name">
        {{ _job.client_company?.name }}
      </div>
    }
    <div
      class="mb-2 d-flex align-items-center justify-content-between"
      [ngClass]="{
        'status-and-icons':
          (templateManager &&
            (_job.files_count > 0 || _job.message_count > 0)) ||
          !templateManager,
      }"
    >
      @if (!templateManager) {
        <div class="status-wrapper">
          <ds-status-badge class="status-badge"
          [pTooltip]="tooltipContent" [autoHide]="false" tooltipPosition="top" [tooltipStyleClass]="'task-groups-tooltip'"
          [color]="['grey', 'blue', 'orange', 'green'][_job.status]"
          [text]="
            ['Not Started', 'In Progress', 'On Hold', 'Completed'][_job.status]
            "
          [user]="_job.assigned_to"
          />

          <ng-template #tooltipContent>
            <app-jobs-groups-due [job]="_job" />
          </ng-template>
        </div>
      }
      <div class="d-flex gap-1">
        @if (_job.files_count > 0) {
          <ds-icon-counter
            tooltip="Attachments"
            icon="tio-attachment"
            [number]="_job.files_count"
          />
        }
        @if (_job.message_count > 0) {
          <ds-icon-counter
            tooltip="Comments"
            icon="tio-comment_vs_outlined"
            [number]="_job?.message_count"
          />
        }

        @if (!templateManager) {
          <ds-pin
            [hovering]="false"
            [type]="pinModel"
            [model]="_job"
            [pin]="_job.pinned_item"
            [company]="_job.client_company"
            [showAssignedTo]="true"
          />
        }
      </div>
    </div>
    <div class="title">
      {{ _job.name }}
    </div>

    <!-- <i class="feather paperclip"></i>
    <span class="comments-counter">{{ _job["files"].length }}</span> -->
    <!-- <div class="more-options">
    <span class="" id="job-card-dropdown-{{ job.id }}" type="button" data-toggle="dropdown" aria-haspopup="true"
      aria-expanded="false">
      <i class="feather more-horizontal"></i>
    </span>
    <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'job-card-dropdown-' + job.id">
      <li class="dropdown-header">ACTIONS</li>
      <li (click)="openDuplicateJobModal(duplicateJobModal, job)">
        <a>Duplicate</a>
      </li>
      <li (click)="openRemoveJobModal(removeJobModal, job)">
        <a>Remove</a>
      </li>
    </ul>
  </div> -->
    <div class="tasks-comments">
      @if (getTotalTasksCount() != 0) {
        <div
          class="progression"
          [ngClass]="{ 'progression-green': getUndoneTasksCount() == 0 }"
        >
          <div
            class="circle"
            [ngClass]="{
              started: getTotalTasksCount() - getUndoneTasksCount() > 0,
            }"
          >
            <i class="feather check"></i>
            <svg
              style="stroke-dasharray: 0 {{
                300 -
                  ((getTotalTasksCount() - getUndoneTasksCount()) /
                    getTotalTasksCount()) *
                    300
              }}% 100 100"
              class="color"
              width="27"
              height="24"
              viewBox="0 0 27 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="1"
                width="25"
                height="22"
                rx="11"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                [ngStyle]="{
                  stroke: getUndoneTasksCount() == '0' ? '#2F9139' : '#0075FF',
                }"
              />
            </svg>
            <svg
              class="bg"
              width="27"
              height="24"
              viewBox="0 0 27 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="1"
                width="25"
                height="22"
                rx="11"
                stroke="#EBEDF0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="text">
            {{ getTotalTasksCount() - getUndoneTasksCount() }}/{{
              getTotalTasksCount()
            }}
            tasks
          </div>
        </div>
      }
      @if (getTotalClientTasksCount() != 0) {
        <div
          class="progression"
          [ngClass]="{ 'progression-green': getUndoneClientTasksCount() == 0 }"
        >
          <div
            class="circle"
            [ngClass]="{
              started:
                getTotalClientTasksCount() - getUndoneClientTasksCount() > 0,
            }"
          >
            <i class="feather check"></i>
            <svg
              style="stroke-dasharray: 0 {{
                300 -
                  ((getTotalClientTasksCount() - getUndoneClientTasksCount()) /
                    getTotalClientTasksCount()) *
                    300
              }}% 100 100;"
              class="color"
              width="27"
              height="24"
              viewBox="0 0 27 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="1"
                width="25"
                height="22"
                rx="11"
                [ngStyle]="{
                  stroke:
                    getUndoneClientTasksCount() == '0' ? '#2F9139' : '#0075FF',
                }"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="bg"
              width="27"
              height="24"
              viewBox="0 0 27 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="1"
                width="25"
                height="22"
                rx="11"
                stroke="#EBEDF0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="text">
            {{ getTotalClientTasksCount() - getUndoneClientTasksCount() }}/{{
              getTotalClientTasksCount()
            }}
            client tasks
          </div>
        </div>
      }
      <!-- <div class="comments-trigger">Comments (1)</div> -->
    </div>
    <div class="header">
      <div class="left d-flex align-items-center">
        @if (_job.urgent) {
          <i
            class="tio-warning urgent-icon"
            tooltip="Urgent"
            placement="top"
          ></i>
        }
        @if (_job?.recurring) {
          <i class="feather repeat" tooltip="Recurring" placement="top"></i>
        }
        @if (!templateManager) {
          <div
            class="due-date"
            [ngClass]="{ overdue: _job['isOverdue'] }"
            tooltip="Due Date"
            placement="top"
          >
            <i class="tio-calendar"></i>
            <span class="date">{{
              mm(_job.due_date, "MM-DD-YYYY") | amDateFormat: "MMM DD, YYYY"
            }}</span>
          </div>
        }
      </div>
    </div>
  </div>
}
